<router-outlet></router-outlet>
<app-version-check></app-version-check>